import './BrandsSkeleton.scss';

const BrandsSkeleton = () => {

    return (
        <>
            <div className='home__brands__section__skeleton'>
                <div className='left__side__brands__section__skeleton'>
                    <div className='brands__content__skeleton'>
                        <div className='brands__accent__skeleton'></div>
                        <div className='brands__title__skeleton'></div>
                        <div className='brands__title__skeleton--primary'></div>
                        <div className='brands__subtitle__wrapper__skeleton'>
                            {[...Array(4)].map((_, index) => (
                                <div key={index} className="brands__subtitle__skeleton" />
                            ))}
                            <div className="brands__subtitle__skeleton--primary"></div>
                        </div>
                    </div>
                </div>
                <div className='right__side__brands__section__skeleton'>
                    <div className='logos_wrapper__skeleton'>
                        {[...Array(9)].map((_, index) => (
                            <div key={index} className="logos__skeleton" />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BrandsSkeleton;